<template>
  <div>
    <form-field-date-picker
      label="Date"
      v-model="date"
      :validation-errors="startAtValidationErrors"
      is-inline
    ></form-field-date-picker>

    <grid-row style="max-width: 310px; margin: 0 auto 1rem;" class="is-mobile">
      <grid-column :size="6" class="pl-0">
        <form-field-time-picker
          label="Start At"
          v-model="startTime"
          type="jsDate"
          is-inline
        ></form-field-time-picker>
      </grid-column>

      <grid-column :size="6">
        <form-field-time-picker
          label="End At"
          v-model="endTime"
          type="jsDate"
          is-inline
        ></form-field-time-picker>
      </grid-column>
    </grid-row>
  </div>
</template>

<script>
import dates from "../../services/dates";

export default {
  name: "FormFieldStartAtEndAtPicker",
  props: {
    startAt: String,
    startAtValidationErrors: Array,
    endAt: String,
  },
  data() {
    return {
      date: dates.getJSDate(this.startAt),
      startTime: dates.getJSDate(this.startAt),
      endTime: dates.getJSDate(this.endAt),
    }
  },
  watch: {
    date () {
      const dateISO = dates.convertJSDateToISO(this.date);

      // Turn startTime to UTC and emit as startAt
      const startTimeISO = dates.convertJSDateToISO(this.startTime);
      const startHour = dates.getHour(startTimeISO);
      const startMinute = dates.getMinute(startTimeISO);
      const startAt = dates.setTime(dateISO, startHour, startMinute);
      const startAtUTC = dates.setToUTC(startAt);
      this.$emit('update:startAt', dates.convertDatetimeToISO(startAtUTC));

      // Turn endTime to UTC and emit as endAt
      const endTimeISO = dates.convertJSDateToISO(this.endTime);
      const endHour = dates.getHour(endTimeISO);
      const endMinute = dates.getMinute(endTimeISO);
      const endAt = dates.setTime(dateISO, endHour, endMinute);
      const endAtUTC = dates.setToUTC(endAt);
      this.$emit('update:endAt', dates.convertDatetimeToISO(endAtUTC));
    },
    startTime (startTime) {
      const dateISO = dates.convertJSDateToISO(this.date);
      const startTimeISO = dates.convertJSDateToISO(startTime);
      const startHour = dates.getHour(startTimeISO);
      const startMinute = dates.getMinute(startTimeISO);

      // Turn startTime to UTC and emit as startAt
      const startAt = dates.setTime(dateISO, startHour, startMinute);
      const startAtUTC = dates.setToUTC(startAt);
      this.$emit('update:startAt', dates.convertDatetimeToISO(startAtUTC));

      // Set endTime to one hour after startTime
      const endTime = dates.setTime(dateISO, startHour + 1, startMinute);
      this.endTime = dates.convertDatetimeToJSDate(endTime);
    },
    endTime (endTime) {
      const dateISO = dates.convertJSDateToISO(this.date);
      const endTimeISO = dates.convertJSDateToISO(endTime);
      const endHour = dates.getHour(endTimeISO);
      const endMinute = dates.getMinute(endTimeISO);

      // Turn endTime to UTC and emit as endAt
      const endAt = dates.setTime(dateISO, endHour, endMinute);
      const endAtUTC = dates.setToUTC(endAt);
      this.$emit('update:endAt', dates.convertDatetimeToISO(endAtUTC));
    },
  },
}
</script>
